import React, {useState, useEffect} from 'react';
import {motion} from 'framer-motion';
import '../styles/News.css';
import newsData from '../data/news.json';
import {Link} from 'react-router-dom';

const News = () => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        // Ici, nous simulons un appel API en utilisant les données du fichier news.json
        setArticles(newsData);
    }, []);

    return (
        <div className="news-page">
            <h1 className="page-title">Actualités Cinéma</h1>

            <div className="articles-grid">
                {articles.map((article, index) => (
                    <motion.article
                        key={article.id}
                        className="news-card"
                        initial={{opacity: 0, y: 20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{delay: index * 0.1}}
                        whileHover={{scale: 1.02}}
                    >
                        <div className="card-image">
                            <img src={article.image} alt={article.title}/>
                            <span className="category-badge">{article.category}</span>
                        </div>
                        <div className="card-content">
                            <div className="meta-info">
                                <time>{new Date(article.date).toLocaleDateString('fr-FR')}</time>
                            </div>
                            <h2>{article.title}</h2>
                            <p>{article.excerpt}</p>
                            <Link to={`/news/${article.id}`}>
                                <div className="read-more-container">
                                    <button className="read-more">Lire la suite →</button>
                                </div>
                            </Link>
                        </div>
                    </motion.article>
                ))}
            </div>
        </div>
    );
};

export default News;